import loadable from '@loadable/component';
export const manifest = {
  'SmeFormPayment.Provider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeFormPaymentProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeFormPaymentProvider" */
          './provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./provider");
            }

            return eval('require.resolve')("./provider");
          }

        }, {
          resolveComponent: m => m.SmeFormPaymentProvider
        })
      }
    }
  },
  'SmeFormPayment.Modal': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeFormPaymentModal";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeFormPaymentModal" */
          './modal'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./modal");
            }

            return eval('require.resolve')("./modal");
          }

        }, {
          resolveComponent: m => m.SmeFormPaymentModal
        })
      }
    }
  }
};